import { render } from "./WaitForCounselorInstant.vue?vue&type=template&id=f4643c04&scoped=true"
import script from "./WaitForCounselorInstant.vue?vue&type=script&lang=js"
export * from "./WaitForCounselorInstant.vue?vue&type=script&lang=js"

import "./WaitForCounselorInstant.vue?vue&type=style&index=0&id=f4643c04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4643c04"]])

export default __exports__